import { render, staticRenderFns } from "./CineChannel.vue?vue&type=template&id=116f70ce&"
import script from "./CineChannel.vue?vue&type=script&lang=js&"
export * from "./CineChannel.vue?vue&type=script&lang=js&"
import style0 from "./CineChannel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports